import { render, staticRenderFns } from "./SalesDivisionEdit.vue?vue&type=template&id=b48db21a&"
import script from "./SalesDivisionEdit.vue?vue&type=script&lang=js&"
export * from "./SalesDivisionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports